import dynamicRouters from '../router/dynamicRouters';
import _ from 'lodash';

// 根据权限生成动态路由
const generateRouters = menus => {
  return new Promise((resolve, reject) => {
    if (menus && menus.length) {
      let newRouters = [];
      let children = [];

      // 根据权限生成一级菜单
      menus.map(menu => {
        dynamicRouters[0].children.map(dymenu => {
          let dmenu = _.cloneDeep(dymenu);
          if (menu.name === dmenu.name) {
            if (dmenu.children && dmenu.children.length) {
              // 存在二级菜单，根据权限生成二级菜单
              if (menu.views.pc && menu.views.pc.length) {
                let submenu = [];
                menu.views.pc.map(view => {
                  dmenu.children.map(dview => {
                    // 处理一级菜单下的子页面
                    if (view.haveMenuSubpage) {
                      let subpage = [];

                      view.auth.map(auth => {
                        if (auth.haveSubpage) {
                          auth.pages.map(page => {
                            if (page === dview.name) {
                              subpage.push(dview);
                            }
                          });
                        }
                      });

                      submenu = subpage;
                    } else {
                      if (dview.name === view.name) {
                        // 处理二级菜单下的子页面
                        if (dview.children && dview.children.length) {
                          let subpage = [];

                          view.auth.map(auth => {
                            if (auth.haveSubpage) {
                              auth.pages.map(page => {
                                dview.children.map(dpage => {
                                  if (page === dpage.name) {
                                    subpage.push(dpage);
                                  }
                                });
                              });
                            }
                          });

                          dview.children = subpage;
                          submenu.push(dview);
                        } else {
                          submenu.push(dview);
                        }
                      }
                    }
                  });
                });

                dmenu.children = submenu;
                dmenu.redirect && (dmenu.redirect = `${dmenu.path}/${dmenu.children[0].path}`)
                children.push(dmenu);
              }
            } else {
              children.push(dmenu);
            }
          }
        });
      });

      let layoutPath = {
        path: '/',
        component: () => import('@/views/layout/index.vue'),
        redirect: children[0].path,
        hidden: true,
        children
      };
      newRouters.push(layoutPath);
      resolve(newRouters);
    } else {
      resolve([]);
    }
  });
};

export default generateRouters;
